import { render, staticRenderFns } from "./SampleInjectionComponent.vue?vue&type=template&id=b5eb7046&scoped=true&"
import script from "./SampleInjectionComponent.vue?vue&type=script&lang=js&"
export * from "./SampleInjectionComponent.vue?vue&type=script&lang=js&"
import style0 from "./SampleInjectionComponent.vue?vue&type=style&index=0&id=b5eb7046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5eb7046",
  null
  
)

export default component.exports